<script>
import AnalyticsDetailRow from "@/components/MultiConnect/Analytics/AnalyticsDetailRow.vue";
import {mapGetters} from "vuex";
import Loading from "@/components/Loading.vue";

export default {
  name: "AttendeeAnalytics",
  components: {Loading, AnalyticsDetailRow},
  props: {
    isPdf: {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      tab: 0,
      items: [
        { name: "Attendee count", value: "count" },
        { name: "Attendee types", value: "types" },
      ],
      countText: 'The total count is based on the number of attendees joined.',
    }
  },
  computed: {
    ...mapGetters(["currentEvent"]),
    generalAttendees() {
      return (this.currentEvent.analyticsData.allAtteneesCount - this.currentEvent.analyticsData.attendeeAnalytics.speakers - this.currentEvent.analyticsData.attendeeAnalytics.partnerRepresentatives - this.currentEvent.analyticsData.attendeeAnalytics.startupScaleUpRespresentatives).toLocaleString();
    },
    speakerAttendee() {
      return this.currentEvent.analyticsData.attendeeAnalytics.speakers.toLocaleString();
    },
    visibleAttendees() {
      return this.currentEvent.analyticsData.attendeeAnalytics.visibleAttendees.toLocaleString();
    },
    hiddenAttendees() {
      return this.currentEvent.analyticsData.attendeeAnalytics.hiddenAttendees.toLocaleString();
    },
    partnerRepresentatives() {
      return this.currentEvent.analyticsData.attendeeAnalytics.partnerRepresentatives.toLocaleString()
    },
    startupsnScaleupsRepresentatives() {
      return this.currentEvent.analyticsData.attendeeAnalytics.startupScaleUpRespresentatives.toLocaleString()
    },
  },
  methods: {
    view(type) {
      this.$router.push({
        name: "attendeesAnalytics",
        query: {
          type: type,
        },
        params: {
          eventId: this.currentEvent.id,
        }});
    }
  }
}
</script>

<template>
  <div>
    <v-card :outlined="isPdf ? false : true" :height="400">
      <v-card-title>Attendees</v-card-title>
      <div>
      <v-card-subtitle class="d-flex justify-space-between align-center py-0">
        <div class="d-flex">
          <img
              :src="require(`@/assets/icons/account.${isPdf ? 'png' : 'svg'}`)"
              width="18"
              contain
              class="mr-2"
         />
          <span style="color: #202020">{{ currentEvent.analyticsData.allAtteneesCount.toLocaleString() }} attendees joined</span><span style="color: #96A4B9" class="px-4">({{ (this.currentEvent.analyticsData.allAtteneesCount - this.currentEvent.analyticsData.noOfAttendeesLeftEvent).toLocaleString()}} current attendees, {{ this.currentEvent.analyticsData.noOfAttendeesLeftEvent }} left the event)</span>
        </div>
      </v-card-subtitle>
      <v-col class="px-4" v-if="!isPdf">
        <v-tabs v-model="tab" active-class="primary--text">
          <v-tab active-class="primary--text" class="text-capitalize" v-for="item in items" :key="item.name">
            {{ item.name }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item class="pt-4">
              <span style="color: #96A4B9" class="px-4">{{countText}}</span>
              <v-col cols="12">
                <AnalyticsDetailRow title="Visible attendees" :value="visibleAttendees" :show-view-button="true" @onView="view(`visible`)" />
                <div class="pb-2">
                  <v-divider class="pa-0" />
                </div>
                <AnalyticsDetailRow title="Hidden attendees" :value="hiddenAttendees" :show-view-button="true" @onView="view(`hidden`)"/>
              </v-col>


          </v-tab-item>
          <v-tab-item class="pt-4">
            <span style="color: #96A4B9" class="px-4">{{countText}}</span>
            <v-col cols="12">
              <AnalyticsDetailRow title="General Attendees" :value="generalAttendees" :show-view-button="true" @onView="view(`general`)"/>
              <div class="pb-2">
                <v-divider class="pa-0" />
              </div>
              <AnalyticsDetailRow title="Speakers" :value="speakerAttendee" :show-view-button="true" @onView="view(`speaker`)"/>
              <div class="pb-2">
                <v-divider class="pa-0" />
              </div>
              <AnalyticsDetailRow title="Partner representatives" :value="partnerRepresentatives" :show-view-button="true" @onView="view(`partnerRepresentatives`)"/>
              <div class="pb-2">
                <v-divider class="pa-0" />
              </div>
              <AnalyticsDetailRow title="Startups & Scaleups representatives" :value="startupsnScaleupsRepresentatives" :show-view-button="true" @onView="view(`startupRepresentatives`)"/>
            </v-col>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
        <div v-else>
          <v-row class="ma-auto">
            <v-col cols="6">
              <v-card outlined height="275">
                <v-card-title >Attendee count</v-card-title>
                <v-card-subtitle class="pb-0"><span style="color: #96A4B9" >{{countText}}</span></v-card-subtitle>
                <v-col cols="12" class="pl-4">
                  <AnalyticsDetailRow title="Visible attendees" :value="visibleAttendees" :show-view-button="!isPdf"/>
                  <div class="pb-2">
                    <v-divider class="pa-0" />
                  </div>
                  <AnalyticsDetailRow title="Hidden attendees" :value="hiddenAttendees" :show-view-button="!isPdf"/>
                </v-col>
              </v-card>
            </v-col>
            <v-col cols="6">
              <v-card outlined >
                <v-card-title >Attendee types</v-card-title>
                <v-card-subtitle class="pb-0"><span style="color: #96A4B9" >{{countText}}</span></v-card-subtitle>
                <v-col cols="12" class="pl-4">
                  <AnalyticsDetailRow title="General Attendees" :value="generalAttendees" :show-view-button="!isPdf"/>
                  <div class="pb-2">
                    <v-divider class="pa-0" />
                  </div>
                  <AnalyticsDetailRow title="Speakers" :value="speakerAttendee" :show-view-button="!isPdf"/>
                  <div class="pb-2">
                    <v-divider class="pa-0" />
                  </div>
                  <AnalyticsDetailRow title="Partner representatives" :value="partnerRepresentatives" :show-view-button="!isPdf"/>
                  <div class="pb-2">
                    <v-divider class="pa-0" />
                  </div>
                  <AnalyticsDetailRow title="Startups & Scaleups representatives" :value="startupsnScaleupsRepresentatives" :show-view-button="!isPdf"/>
                </v-col>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </div>
    </v-card>

  </div>
</template>

<style scoped>

</style>